/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Shipping1: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 1H0V3H9V1ZM9 5H2V7H9V5ZM4 9H9V11H4V9ZM9 13H6V15H9V13ZM19.858 9.311L23.447 11.105C23.786 11.275 24 11.621 24 12V18C24 18.552 23.552 19 23 19H19.949C19.697 21.244 17.81 23 15.5 23C13.19 23 11.303 21.244 11.051 19C11.051 19 11 18.549 11 18V5H16.375H18C18.459 5 18.859 5.312 18.97 5.758L19.858 9.311ZM13 18.5C13 19.879 14.122 21 15.5 21C16.878 21 18 19.879 18 18.5C18 17.121 16.878 16 15.5 16C14.122 16 13 17.121 13 18.5ZM13 7V10H18L17.344 7H13Z'
      fill='currentColor'
    />
  </React.Fragment>
)
